import React, { useCallback, useContext } from 'react';

import { RiskAssessmentHazardContext } from '../../risk-assessment-hazard.context';
import RiskAssessmentHazardForm from '../Form';

export default function EditDialog() {
  const { editDialogOpened, setEditDialogOpened, selectedData, reload } = useContext(RiskAssessmentHazardContext);
  const closeDialog = useCallback(
    (success: boolean) => {
      if (success) {
        reload();
      }
      setEditDialogOpened(false);
    },
    [reload, setEditDialogOpened]
  );

  return <RiskAssessmentHazardForm open={editDialogOpened} onClose={closeDialog} data={selectedData} />;
}
